import * as React from 'react';
import { Container, Button, ExpandingBackground, ButtonContentContainer } from './styled';

interface Props {
    expanded: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    children: React.ReactNode;
    className?: string;
    actionSubjectId: string;
}

const ExpandingButton: React.StatelessComponent<Props> = ({
    expanded,
    onClick,
    children,
    className,
    actionSubjectId,
}) => (
    <Container className={className} expanded={expanded}>
        <ExpandingBackground expanded={expanded} />

        <Button onClick={onClick} expanded={expanded} aria-haspopup="dialog" actionSubjectId={actionSubjectId}>
            <ButtonContentContainer>{children}</ButtonContentContainer>
        </Button>
    </Container>
);

export default ExpandingButton;
